import {
  TableWithoutWrapper,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";

import { SettingsTableProps } from "./types";
import { TableLoading } from "./TableLoading";
import { EmptyTablePlaceholder } from "./EmptyTablePlaceholder";
import { TableActions } from "./TableActions";

export function SettingsTable<DataT>({
  data,
  columns,
  actions,
  isLoading = false,
  keyExtractor,
  emptyStateMessage = "No data found",
}: SettingsTableProps<DataT>) {
  return (
    <div className="mb-4 mt-4 max-h-[450px] overflow-x-auto overflow-y-auto rounded-md border">
      <TableWithoutWrapper>
        <TableHeader className="shadow-sm">
          <TableRow>
            {columns.map((column) => (
              <TableHead key={column.header}>{column.header}</TableHead>
            ))}
            {actions && actions.length > 0 && (
              <TableHead className="min-w-[34px] max-w-[34px]" />
            )}
          </TableRow>
        </TableHeader>
        <TableBody>
          {isLoading ? (
            <TableLoading
              colSpan={
                actions && actions.length > 0
                  ? columns.length + 1
                  : columns.length
              }
            />
          ) : data.length === 0 ? (
            <EmptyTablePlaceholder
              emptyStateMessage={emptyStateMessage}
              colSpan={
                actions && actions.length > 0
                  ? columns.length + 1
                  : columns.length
              }
            />
          ) : (
            data.map((item) => (
              <TableRow key={keyExtractor(item)}>
                {columns.map((column, index) => (
                  <TableCell key={`${keyExtractor(item)}-${index}`}>
                    {column.content(item)}
                  </TableCell>
                ))}
                <TableActions<DataT> actions={actions} item={item} />
              </TableRow>
            ))
          )}
        </TableBody>
      </TableWithoutWrapper>
    </div>
  );
}
